export const isDecimalValue = (value: string) => {
  return value.match(/^[0-9]+(\.[0-9]+)$/);
};
